import "./SharedComponents/sharedComponents.css"
import {Component} from 'react';

class HomeButtonCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
         }
    }
           
    render() {
    return <>
        <div className="text-center">
            <button className="btn btn-primary w-75 text-center mt-2"
                onClick={() => this.props.onClick(this.props.slctHome)}>
                    {this.props.slctHome.description}
            </button>    
        </div>
    </>
    }
}


export default HomeButtonCard;